import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import { getContent } from '@/services/api';
import SocialShare from '@/components/SocialShare';
import Placeholder from '@/components/Placeholder';
import Markdown from '@/components/Markdown';
import {
  Wrapper,
  ResultCopySection,
  ResultCopyContainer,
  MarkdownStyle,
  ResultSection,
  ButtonWrapper,
  SalonLocatorLinkSection,
  Button,
} from '@/pages/HairDiagnosis/HairDiagnosisResultPage/HairDiagnosisResultPage.style';
import Hero from './Hero/Hero';
import SalonMenuResult from './SalonMenuResult';
import HomeCareResult from './HomeCareResult';

import { fetchHairDiagnosis } from '../../../redux/actions/hairDiagnosis';

const parsUrlParameter = (paramString) => {
  if (!paramString) return null;

  const paramArray = paramString.slice(1).split('&');

  const parameter = paramArray.reduce((prev, param) => {
    const keyValue = param.split('=');
    const key = decodeURIComponent(keyValue[0]);
    const value = decodeURIComponent(keyValue[1]);

    prev[key] = value;
    return prev;
  }, {});

  return parameter;
}

const createUrlParameter = (locale,name,salonMenuResult,homeCareResult) => {
  const urlParam = {
    name: name || null,
    salonMenuResult: _.get(salonMenuResult, 'slug') || null,
    homeCareResult: _.get(homeCareResult, 'slug') || null,
  };

  const queryString = Object.keys(urlParam).reduce((prev, key) => {
    if (!urlParam[key]) return prev;

    const prefix = !prev ? '?' : '&';
    return prev + prefix + key + '=' + urlParam[key];
  }, '');

  const endpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : process.env.NODE_ENV === 'production' ? 'https://www.shiseido-professional.com' : window.location.href.split('/')[0];
  return `${endpoint}/${locale}/beauty-consultation/results${queryString}`;
}

class HairDiagnosisResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: false,
      fromMail: false,
      scUserData: {},
      result: null,
      sendMailSuccess: false,
      // SEO 対策に必要なメタデータ
      siteOptionsMetaData: {},
      // サロンメニュー (slug 加算数が多いものを格納)
      salonMenuResult: {},
      // ホームケア (slug 加算数が多いものを格納)
      homeCareResult: {},
    };

    const { hairDiagnosis, locale, fetchHairDiagnosis } = this.props;
    if (!hairDiagnosis.title) {
      fetchHairDiagnosis(locale);
    }

  }

  componentWillMount() {
    const { locale, results } = this.props;

    if (locale) {
      // SEO 対策に必要なメタデータを取得する
      getContent({ contentType: 'siteOptionsMetaData', locale, slug: 'beauty-consultation' }).then(siteOptionsMetaData =>
        this.setState({ siteOptionsMetaData })
      );
    }

    if (results) {
      this.setItemsByResult(results);
    }
  }

  componentWillReceiveProps(props) {
    const { hairDiagnosis } = props;

    if (hairDiagnosis.title) {
      const getParam = parsUrlParameter(this.props.location.search);
      
      if(getParam) {
        const result = this.getResultObject({
          salon: getParam.salonMenuResult,
          home: getParam.homeCareResult,
        }, hairDiagnosis);
        
        this.setState({
          userData: {
            name: getParam.name
          },
          ...result
        });
      }
    }
  }

  componentDidMount() {
    const { salonMenuResult, homeCareResult } = this.state;

    if (!(salonMenuResult && homeCareResult)) {
      const { results } = this.props;
      if (results) this.setItemsByResult(results);    
    }
  }

  addResultCount(rslt, val) {
    if (!Array.isArray(val)) {
      rslt[val.slug] = rslt[val.slug] ? rslt[val.slug] + 1 : 1;
      return rslt;
    }
    
    return val.reduce((prev, value) => {
      prev[value.slug] = prev[value.slug] ? prev[value.slug] + 1 : 1;
      return prev;
    }, rslt);
  }

  mergeResultCount(result, val) {
    return Object.keys(val).reduce((prev, v) => {
      if(prev[v]) {
        prev[v] = prev[v] + val[v];
      } else {
        prev[v] = val[v];
      }
      return prev;
    },result);
  }
  
  getResultCountArray(Arr) {
    const init = {
      salon: {},
      home: {},
    }
    
    return Arr.reduce((prev, value) => {
      if(Array.isArray(value)) {
        const result = this.getResultCountArray(value);
        prev.salon = this.mergeResultCount(prev.salon, result.salon);
        prev.home = this.mergeResultCount(prev.home, result.home);

        return prev;
      }

      const { salonMenuResult, homeCareResult } = value;
      prev.salon = this.addResultCount(prev.salon, salonMenuResult);
      prev.home = this.addResultCount(prev.home, homeCareResult);

      return prev;
    },init);
  }

  getResultCount(Arr) {
    const resultCount = this.getResultCountArray(Arr);

    const salon = this.getSlugOfMaxResultCount(resultCount.salon);
    const home = this.getSlugOfMaxResultCount(resultCount.home);
    
    const result = {
      salon: salon.length > 1 ? this.getSalonConflictResult(salon) : salon[0],
      home: home.length > 1 ? this.getHomeConflictResult(home) : home[0],
    }
    return this.getResultObject(result);
  }

  getSlugOfMaxResultCount(obj) {
    const keyArr = Object.keys(obj);
    const MaxVal = keyArr.reduce((prev, key) => prev > obj[key] ? prev : obj[key], 0);

    return keyArr.filter(key => obj[key] === MaxVal);
  }

  getSalonConflictResult(array) {
    const { results } = this.props;
    const firstSalonMenuResult = results[0].salonMenuResult;
    const secondSalonMenuResult = results[1].salonMenuResult;

    const firstIndex = array.indexOf(firstSalonMenuResult.slug);    
    if (firstIndex > -1) return array[firstIndex];

    const secondIndex = array.indexOf(secondSalonMenuResult.slug);    
    if (secondIndex > -1) return array[secondIndex];

    console.error({
      salonMenuResult: array
    });
    return '';
  }

  getHomeConflictResult(array) {
    const { results } = this.props;
    const firstHomeCareResult = results[0].homeCareResult;
    const secondHomeCareResult = results[1].homeCareResult;

    const firstQuestionResult = firstHomeCareResult.reduce((prev, value) => {
      const index = array.indexOf(value.slug);
      if(index > -1) {
        prev.push(array[index]);
      }
      return prev;
    }, []);

    if (firstQuestionResult.length === 1) return firstQuestionResult[0];

    const secondQuestionResult = secondHomeCareResult.reduce((prev, value) => {
      const index = array.indexOf(value.slug);
      if(index > -1) {
        prev.push(array[index]);
      }
      return prev;
    }, []);

    if (secondQuestionResult.length === 1) return secondQuestionResult[0];

    const aidIndex = array.indexOf('Concern-AID');
    if (aidIndex > -1) {
      return array[aidIndex];
    }

    const ffdsIndex = array.indexOf('Concern-FFDS');
    if (ffdsIndex > -1) {
      return array[ffdsIndex];
    }

    console.error({
      homeCareResult: array
    });

    return '';
  }

  getResultObject(result, hairDiagnosis = this.props.hairDiagnosis) {
    const{ salonMenuResult, homeCareResult } = hairDiagnosis;
    return {
      salonMenuResult: salonMenuResult.reduce((prev, value) => {
          if(result.salon === value.slug) {
            return value;
          }
          return prev;
        }, null),
      homeCareResult: homeCareResult.reduce((prev, value) => {
          if(result.home === value.slug) {
            return value;
          }
          return prev;
        }, null),
    }
  }

  setItemsByResult = results => {
    const resultObject = this.getResultCount(results);
    this.setState(resultObject);    
  };

  render() {
    const { copy, locale, userData } = this.props;
    const { siteCopyHairDiagnosisSummary, siteCopySnsLink } = copy;
    const { siteOptionsMetaData, salonMenuResult, homeCareResult } = this.state;    
    const userName = userData.name || (this.state.userData ? this.state.userData.name : null);

    return (
      <Wrapper>
        {_.get(siteOptionsMetaData, 'metaData') && (
          <Helmet
            title={_.get(siteOptionsMetaData.metaData, 'title')}
            meta={[
              {
                name: 'description',
                content: _.get(siteOptionsMetaData.metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(siteOptionsMetaData.metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(siteOptionsMetaData.metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(siteOptionsMetaData.metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(siteOptionsMetaData.metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(siteOptionsMetaData.metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(siteOptionsMetaData.metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(siteOptionsMetaData.metaData, 'siteName'),
              // },
            ]}
          />
        )}
        {siteCopyHairDiagnosisSummary && userName && <Hero user={{ name: userName }} copy={siteCopyHairDiagnosisSummary} />}
        <ResultCopySection>
          {!(_.get(siteCopyHairDiagnosisSummary, 're_diagnosis') && _.get(homeCareResult, 'color') && _.get(homeCareResult, 'beautyConsultationResultCopy')) ? <Placeholder w="100%" h="100px" /> : (
            <ResultCopyContainer background={homeCareResult.color}>
              <Markdown src={homeCareResult.beautyConsultationResultCopy} Component={MarkdownStyle} />
              <Link to={`/${locale}/beauty-consultation`} href={`/${locale}/beauty-consultation`}>
                <ButtonWrapper>
                  <Button>
                      {siteCopyHairDiagnosisSummary.re_diagnosis}
                  </Button>
                </ButtonWrapper>
              </Link>
            </ResultCopyContainer>
          )}
        </ResultCopySection>
        <ResultSection>
          <SalonMenuResult salonMenuResult={salonMenuResult} />
          <HomeCareResult homeCareResult={homeCareResult} />
        </ResultSection>
        <SalonLocatorLinkSection>
          <Link to={`/${locale}/beauty-consultation`} href={`/${locale}/beauty-consultation`}>
            <ButtonWrapper>
              <Button>
                  {siteCopyHairDiagnosisSummary && siteCopyHairDiagnosisSummary.re_diagnosis ? siteCopyHairDiagnosisSummary.re_diagnosis : <Placeholder w="50%" h="16px" />}
              </Button>
            </ButtonWrapper>
          </Link>
          <Link to={`/${locale}/salon-locator`} href={`/${locale}/salon-locator`}>
            <ButtonWrapper>
              <Button>
              {siteCopyHairDiagnosisSummary && siteCopyHairDiagnosisSummary.salon_locator_cta ? siteCopyHairDiagnosisSummary.salon_locator_cta : <Placeholder w="50%" h="16px" />}
              </Button>
            </ButtonWrapper>
          </Link>
        </SalonLocatorLinkSection>
        <SocialShare 
          siteCopySnsLink={siteCopySnsLink}
          shareUrl={createUrlParameter(locale,userName,salonMenuResult,homeCareResult)}
          twitterText={homeCareResult ? homeCareResult.beautyConsultationResultCopy : ''}
        />
      </Wrapper>
    );
  }
}

HairDiagnosisResultPage.defaultProps = {
  userData: {},
};

HairDiagnosisResultPage.propTypes = {
  hairDiagnosis: PropTypes.shape({}).isRequired,
  locale: PropTypes.string.isRequired,
  copy: PropTypes.shape(),
  userData: PropTypes.shape({}),
};

const mapState = state => ({
  copy: state.siteOptions,
  locale: state.locale,
  // ユーザーデータ
  userData: state.beautyConsultationDiagnosis.userData,
  // 診断結果
  results:  state.beautyConsultationDiagnosis.results,
  userAndStylistDiagnosisResult: state.sublimicDiagnosis,
  hairDiagnosis: state.hairDiagnosis,
});

const mapDispatch = dispatch => ({
  fetchHairDiagnosis: locale => dispatch(fetchHairDiagnosis(locale)),
});

export default connect(mapState, mapDispatch)(HairDiagnosisResultPage);



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/HairDiagnosisResultPage.js